// =====================================================
// GALLERY — Images aur Videos yahan add karo
// =====================================================
//
// IMAGE entry:
//   { type: 'image', src: '/gallery/photo1.jpg', alt: 'Description' }
//
// VIDEO entry (local file — public/gallery/ mein rakho):
//   { type: 'video', src: '/gallery/video1.mp4', alt: 'Video description' }
//
// YouTube Video (click karne pe YouTube pe open hoga):
//   { type: 'youtube', src: 'https://www.youtube.com/watch?v=VIDEO_ID', alt: 'Description' }
//
// Instagram Reel/Post (click karne pe Instagram pe open hoga):
//   { type: 'instagram', src: 'https://www.instagram.com/reel/POST_ID/', alt: 'Description' }
//
// =====================================================

const galleryItems = [
  { type: 'image', src: '/gallery/pic1.jpg', alt: 'Student at school' },
  { type: 'image', src: '/gallery/pic2.jpg', alt: 'Classroom activity' },
  { type: 'image', src: '/gallery/pic3.jpg', alt: 'Art and craft' },
  { type: 'image', src: '/gallery/pic4.jpg', alt: 'Outdoor fun' },
  { type: 'image', src: '/gallery/pic5.jpg', alt: 'Story time' },
  { type: 'image', src: '/gallery/pic6.jpg', alt: 'Learning together' },

  // ---- Videos (baad mein apna src change kar lena) ----
  { type: 'youtube', src: 'https://youtube.com/@kidsplayhall16125?si=gyzsvQPEdqG8IEHH', alt: 'Kids Play Hall videos' },
  { type: 'instagram', src: 'https://www.instagram.com/kidsplayhall.16125/', alt: 'Kids Play Hall Reels' },
  // { type: 'video', src: '/gallery/video1.mp4', alt: 'Kids activity video' },
];

export default galleryItems;
